import {autoserializeAs, inheritSerialization} from "dcerialize";
import type {IdentifiableModel} from "../base/IdentifiableModel";
import {type Existing} from "../base/IdentifiableModel";
import type {ModificationTrackedModel} from "../base/ModificationTrackedModel";
import {ModificationDetails} from "../ModificationDetails";

export type CountryCode = string;

export class CodeOnlyCountry implements IdentifiableModel<CountryCode> {
  @autoserializeAs(() => String)
  public code: CountryCode;

  public get id(): CountryCode {
    return this.code;
  }

  public set id(id: CountryCode) {
    this.code = id;
  }

  public static existing(code: CountryCode): Existing<CodeOnlyCountry> {
    return new CodeOnlyCountry(code);
  }

  public constructor(code: CountryCode) {
    this.code = code;
  }
}

@inheritSerialization(() => CodeOnlyCountry)
export class SimpleCountry extends CodeOnlyCountry {
  @autoserializeAs(() => String)
  public readonly name: string;
}

@inheritSerialization(() => SimpleCountry)
export class Country extends SimpleCountry implements ModificationTrackedModel {
  @autoserializeAs(() => ModificationDetails)
  public readonly modificationDetails?: ModificationDetails;
}

/**
 * @sealed
 */
export class CountryTranslation implements ModificationTrackedModel {
  @autoserializeAs(() => String)
  public name: string;
  @autoserializeAs(() => ModificationDetails)
  public readonly modificationDetails?: ModificationDetails;

  public static createEmpty(): CountryTranslation {
    const translation = new CountryTranslation();
    translation.name = "";
    return translation;
  }
}
